import { render, staticRenderFns } from "./servicesCn.vue?vue&type=template&id=0e91c3c2&scoped=true&"
import script from "./servicesCn.vue?vue&type=script&lang=js&"
export * from "./servicesCn.vue?vue&type=script&lang=js&"
import style0 from "./servicesCn.vue?vue&type=style&index=0&id=0e91c3c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e91c3c2",
  null
  
)

export default component.exports